import { BButtonToolbar } from './button-toolbar';
import { pluginFactory } from '../../utils/plugins';
var ButtonToolbarPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BButtonToolbar: BButtonToolbar,
    BBtnToolbar: BButtonToolbar
  }
});
export { ButtonToolbarPlugin, BButtonToolbar };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/button-toolbar/index.js
// module id = 170
// module chunks = 0